var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "createTrip"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("New FTC Cash Deposit")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Trip List"
    },
    on: {
      "click": _vm.showCreateFTCShipment
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("WayBill Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "options": _vm.arrWayBillNumbers,
      "name": "arrWayBillNumbers",
      "id": "arrWayBillNumbers",
      "placeholder": "Select WayBill Number",
      "label": "awb",
      "track-by": "awb",
      "multiple": true,
      "scroll": true,
      "hide-selected": true
    },
    on: {
      "select": _vm.onSelectWayBill,
      "remove": _vm.onRemoveWayBillNumber
    },
    model: {
      value: (_vm.mdlWayBillNumber),
      callback: function($$v) {
        _vm.mdlWayBillNumber = $$v
      },
      expression: "mdlWayBillNumber"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.lblWayBillErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "margin-amount"
  }, [_c('strong', [_vm._v("Cash Collectible")]), _vm._v(" : "), _c('b-badge', {
    staticClass: "reviewLineHeight",
    attrs: {
      "pill": "",
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.lblCashCollectible) + " ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Bank")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.banklist,
      "placeholder": "Select Bank",
      "id": "bankname",
      "append-to-body": true,
      "name": "bankName"
    },
    on: {
      "select": _vm.selectBank
    },
    model: {
      value: (_vm.bankName),
      callback: function($$v) {
        _vm.bankName = $$v
      },
      expression: "bankName"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.bankNameErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.branchName),
      expression: "branchName"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "branchName",
      "id": "branchName",
      "placeholder": "Branch Name"
    },
    domProps: {
      "value": (_vm.branchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.branchName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.branchNameErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Account Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accountNumber),
      expression: "accountNumber"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "accountNumber",
      "id": "accountNumber",
      "placeholder": "Account Number"
    },
    domProps: {
      "value": (_vm.accountNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accountNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.accountNumberErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Cash Deposit Amount (INR)")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cashDepositAmount),
      expression: "cashDepositAmount"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "maxlength": "10",
      "type": "text",
      "name": "cashDepositAmount",
      "id": "cashDepositAmount",
      "placeholder": "Enter Cash Deposit Amount"
    },
    domProps: {
      "value": (_vm.cashDepositAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cashDepositAmount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.cashDepositAmountErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Cash Deposit Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cashDepositDate),
      expression: "cashDepositDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "max": _vm.dt,
      "name": "cashDepositDate"
    },
    domProps: {
      "value": (_vm.cashDepositDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cashDepositDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.cashDepositDateErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Cash Deposit By")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cashDepositBy),
      expression: "cashDepositBy"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "cashDepositBy",
      "id": "cashDepositBy",
      "placeholder": "Enter Cash Deposit By"
    },
    domProps: {
      "value": (_vm.cashDepositBy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cashDepositBy = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.cashDepositByErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Cash Deposit Slip Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cashDepositSlip),
      expression: "cashDepositSlip"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "cashDepositSlip",
      "id": "cashDepositSlip",
      "placeholder": "Enter Cash Deposit Slip Number"
    },
    domProps: {
      "value": (_vm.cashDepositSlip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cashDepositSlip = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.cashDepositSlipErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "2rem"
    }
  }, [_c('label', {
    attrs: {
      "for": "files"
    }
  }, [_vm._v(" Upload deposit slip image\n                "), _c('i', {
    staticClass: "fa fa-upload",
    staticStyle: {
      "font-size": "15px",
      "color": "black",
      "cursor": "pointer"
    }
  })]), _vm._v(" "), _c('b-input-group', [_c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "accept": ".jpeg,.jpg,.png",
      "id": "files",
      "name": "Image"
    },
    on: {
      "click": function($event) {
        _vm.validateUpload($event)
      },
      "change": function($event) {
        _vm.handleFileUpload($event)
      }
    }
  })]), (_vm.filename != '') ? _c('span', [_c('div', {
    staticClass: "clientnote "
  }, [_vm._v(_vm._s(_vm.filename))])]) : _vm._e(), _vm._v(" "), (_vm.filename == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.depositImageErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "2rem"
    }
  }, [_c('label', [_vm._v("View uploaded image")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file-image-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Open Image"
    },
    on: {
      "click": function($event) {
        _vm.openImage(_vm.depositImage)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.depositImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.depositImage
    }
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.depositImage)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.depositImage,
      "src": _vm.depositImage
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "49rem"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveFTCDeposit
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v("   \n                "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624a406e","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/FTCHubCashDeposit/createFTCHubCashDeposit/createFTCHubCashDeposit.component.html
// module id = 1435
// module chunks = 3